module.exports = __webpack_public_path__ + "media/images/icon-SecureCredentials-424efbe0.png";